import { LoadingOverlay } from '@mantine/core';
import React from 'react';

import {
  useOrganizationConfig,
  usePortalConfig,
} from '@portals/api/organizations';
import {
  isCustomerFeatureAll,
  isCustomerFeatureLabOnly,
  SignUp as SinglePageSignUp,
} from '@portals/framework';

import { SignUpWizard } from './SignUpWizard';

export function SignUp(props) {
  const portalConfig = usePortalConfig();
  const organizationConfig = useOrganizationConfig();

  if (!portalConfig.isFetched) return <LoadingOverlay visible />;

  if (
    isCustomerFeatureAll(portalConfig.data?.b2c_view) ||
    isCustomerFeatureLabOnly(
      portalConfig.data?.b2c_view,
      organizationConfig?.lab
    )
  ) {
    return <SinglePageSignUp {...props} />;
  }

  return <SignUpWizard {...props} />;
}
